export const MAINTENANCE_PAGE = 'maintenance/MAINTENANCE_PAGE'
